import Controller from "./editableSchedules.controller";
import template from "./editableSchedules.html";

const editableSchedules = {
  template,
  controller: Controller,
  bindings: {
    schedules: "=",
    eventName: "<",
    reflectEvent: "<",
    deleteEvent: "<",
    addErrorEvent: "<",
    showActions: "<",
    permissionName: "@",
    route: "<",
    updateReservationEvent: "<",
    hideEdit: "<",
  },
};

export default editableSchedules;



// WEBPACK FOOTER //
// ./src/components/editableSchedules/editableSchedules.component.js